import ThreeDottedMenu from './ThreeDottedMenu';

export default ThreeDottedMenu;
